import { MarqCommonEnumsDomainTypeEnum } from '~/swagger/data-contracts';
import { DomainTypeEnum } from '~/types/common/DomainTypeEnum';

/**
 * @note-jamie: [PROD-11001] 전사적으로 쓰이는 워딩이 업데이트됨에 따라,
 * FE코드에서도 가능한한 ecommerce -> marketplace 로 변경하지만,
 * BE와 통신하는 부분과 amplitude는 기존 이름을 일단은 유지하기 위해 이 함수를 사용.
 */

/**
 * View 전용 enum -> API param
 * 'marketplace' => ['ecommerce'], 'marketplace,social_media' => ['ecommerce', 'social_media']
 */
export const parseDomainTypeToApiParam = (
  domainType: DomainTypeEnum | DomainTypeEnum[]
): MarqCommonEnumsDomainTypeEnum[] => {
  switch (domainType) {
    case DomainTypeEnum.Marketplace:
      return [MarqCommonEnumsDomainTypeEnum.Ecommerce];
    case DomainTypeEnum.SocialMedia:
      return [MarqCommonEnumsDomainTypeEnum.SocialMedia];
    case DomainTypeEnum.MarketplaceAndSocialMedia:
      return [MarqCommonEnumsDomainTypeEnum.Ecommerce, MarqCommonEnumsDomainTypeEnum.SocialMedia];
    default:
      return [MarqCommonEnumsDomainTypeEnum.StandAlone];
  }
};

/**
 API param -> View 전용 enum
 ['ecommerce', 'social_media'] => 'marketplace,social_media'
*/
export const parseApiParamToDomainType = (
  domainType: MarqCommonEnumsDomainTypeEnum | MarqCommonEnumsDomainTypeEnum[]
): string => {
  const hasMarketplace = domainType.includes(MarqCommonEnumsDomainTypeEnum.Ecommerce);
  const hasSocialMedia = domainType.includes(MarqCommonEnumsDomainTypeEnum.SocialMedia);
  const hasWebsite = domainType.includes(MarqCommonEnumsDomainTypeEnum.StandAlone);

  if (hasMarketplace && hasSocialMedia) {
    return DomainTypeEnum.MarketplaceAndSocialMedia;
  } else if (hasMarketplace) {
    return DomainTypeEnum.Marketplace;
  } else if (hasSocialMedia) {
    return DomainTypeEnum.SocialMedia;
  } else if (hasWebsite) {
    return DomainTypeEnum.Website;
  }

  return DomainTypeEnum.Marketplace;
};

/**
 Query param / Path param -> View 전용 enum
 ['marketplace','social_media'] => 'marketplace,social_media'
*/
export const parseUrlParamToDomainType = (domainType?: DomainTypeEnum | DomainTypeEnum[]): DomainTypeEnum => {
  const hasMarketplace = domainType?.includes(DomainTypeEnum.Marketplace);
  const hasSocialMedia = domainType?.includes(DomainTypeEnum.SocialMedia);
  const hasWebsite = domainType?.includes(DomainTypeEnum.Website);

  if (hasMarketplace && hasSocialMedia) {
    return DomainTypeEnum.MarketplaceAndSocialMedia;
  } else if (hasMarketplace) {
    return DomainTypeEnum.Marketplace;
  } else if (hasSocialMedia) {
    return DomainTypeEnum.SocialMedia;
  } else if (hasWebsite) {
    return DomainTypeEnum.Website;
  }

  return DomainTypeEnum.Marketplace;
};
